import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClient } from '@angular/common/http';
import { registerLocaleData, DatePipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';


import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MentionModule } from 'angular-mentions';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { NgChartsModule } from 'ng2-charts';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SocialLoginModule, GoogleLoginProvider, FacebookLoginProvider, SocialAuthServiceConfig } from "@abacritt/angularx-social-login";

import { AppComponent } from "./app.component";
import { UrlHandlingStrategy } from '@angular/router';
import { AppRoutingModule } from "./app-routing.module";
import { ReactAwareUrlHandlingStrategy } from './strategies/react-aware-url-handling.strategy';
import { DataUtils } from 'app/utils/data.utils';
import { Navegacao } from "./commons/navegacao";
import { AuthGuard } from "./shared/auth/auth-guard.service";
import { MenuRoutes } from "./shared/sidebar/sidebar-routes.config";
import { DssLayoutComponent } from './layouts/dss/dss-layout.component';
import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { ToastrService } from "./services/toastr.service";
import { TenantGuard } from "./guard/tenant.guard";
import { CameraModule } from './camera';
import { GenericModule } from './pages/generic.module';
import { ContaService } from './pages/full-pages/conta/conta.service';
import { CoreProvidersModule } from './core/core-providers.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localePt);
registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    DssLayoutComponent,
    FullLayoutComponent,
    ContentLayoutComponent,
  ],
  exports: [],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    CoreProvidersModule,
    NgbModule,
    NgxBootstrapMultiselectModule,
    NgxChartsModule,
    InfiniteScrollModule,
    SocialLoginModule,
    GenericModule,
    NgChartsModule,
    MentionModule,
    MatToolbarModule,
    MatButtonModule,
    CameraModule,
    MatLegacyDialogModule,
  ],
  providers: [
    AuthGuard,
    TenantGuard,
    DataUtils,
    ToastrService,
    Navegacao,
    MenuRoutes,
    ContaService,
    DatePipe,
    { provide: UrlHandlingStrategy, useClass: ReactAwareUrlHandlingStrategy },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider("2348299415227140")
          },
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider("548169308315-32it24jbm2fe4mhcf8rsvvqj29h8su8l.apps.googleusercontent.com")
          }
        ]
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
